<template>
  <v-row justify="center">
    <v-dialog v-model="isShowWarning" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          <v-icon large color="yellow accent-4">
            mdi-Alert
          </v-icon>
          Use Google's location service?
        </v-card-title>
        <v-card-text>
          {{ SuccessCount }} payments processed successfully while
          {{ ErrorCount }} failed:
          <ul id="v-for-object" class="demo">
            <li style="color:red;" v-for="value in Errors" :key="value">
              {{ value }}
            </li>
          </ul>
          Ensure that the successful payment information is removed when
          resubmitting file.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeWarningModal">
            Disagree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<!--<template>
  <v-alert
    border="left"
    colored-border
    color="yellow accent-4"
    elevation="2"
    :dismissible="true"
    type="warning"
    :value="isShowWarning"
  >
    {{ SuccessCount }} payments processed successfully while
    {{ ErrorCount }} failed:
    <ul id="v-for-object" class="demo">
      <li style="color:red;" v-for="value in Errors" :key="value">
        {{ value }}
      </li>
    </ul>
    Ensure that the successful payment information is removed when resubmitting
    file.
  </v-alert>
</template>
-->
<script>
export default {
  props: {
    ErrorCount: {
      type: Number,
      default: 0,
      required: true
    },
    SuccessCount: {
      type: Number,
      default: 0,
      required: true
    },
    Errors: {
      type: Array,
      required: true
    },
    isShowWarning: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  methods: {
    closeWarningModal() {
      this.$emit("closeWarningModal");
    }
  }
};
</script>

<style lang="scss" scoped>
.v-alert {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
}
</style>
